import { render, staticRenderFns } from "./Satellites.vue?vue&type=template&id=4803f2ac&scoped=true"
import script from "./Satellites.vue?vue&type=script&lang=js"
export * from "./Satellites.vue?vue&type=script&lang=js"
import style0 from "./Satellites.vue?vue&type=style&index=0&id=4803f2ac&prod&lang=scss&scoped=true"
import style1 from "./Satellites.vue?vue&type=style&index=1&id=4803f2ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803f2ac",
  null
  
)

export default component.exports